import React from 'react';

const IconPhp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <path fill="#9E9E9E" d="M6 22L14 8h4l-6 14h6l-8 16h-4l6-14H6z" />
    <path
      fill="#777BB3"
      d="M24 22l8-14h4l-6 14h6l-8 16h-4l6-14h-6zm12 0l8-14h4l-6 14h6l-8 16h-4l6-14h-6z"
    />
  </svg>
);

export default IconPhp;
